const DepthFirstNodeDependencyMap = (nodes, links) => {
  let orderedNodes = [...nodes].sort((a, b) => b.nivel - a.nivel);

  const DSS = {
    nodes,
    links,
    levels: [...new Array(13)].map(e => new Set()),
    remainingNodes: orderedNodes,
  };

  const maxIterations = 10000;
  let i = 0;
  // While there are nodes
  while (DSS.remainingNodes.length && i++ < maxIterations) {
    // Get first node of the nodes
    var currentNode = DSS.remainingNodes.shift();
    // Add current node to the corresponding level
    DSS.levels[currentNode.nivel].add(currentNode);

    // For all children
    links.filter(l => l.source.id === currentNode.id).forEach(l => {
      // Get the child node
      const n = orderedNodes.find(n => n.id === l.target.id);
      // If child node exits
      if (n && ! n.inspected) {
        n.inspected = true;
        // Add it to the remaining nodes list
        DSS.remainingNodes.unshift(n);
      }
    });
  }
  if (i >= maxIterations) {
    alert('Carregamento infinito detectado, por favor, reporte esse erro.')
    console.error('Infinite loop detected');
  }

  // Map sets to their index and filter out all === 0
  const levels = DSS.levels.map((s, i) => s.size > 0 ? i : 0).filter(e => e);
  const lowestLevel = levels[0];
  const highestLevel = levels.pop();

  // Get nodes by order
  let nodeLine = [];
  DSS.levels.filter(s => s.size).forEach(s => {
    nodeLine = [...nodeLine, ...Array.from(s).reverse()];
  });

  return {
    ...DSS,
    lowestLevel,
    highestLevel,
    nodeLine,
  };
};

export {
  DepthFirstNodeDependencyMap,
};

export default {
  DepthFirstNodeDependencyMap,
};



// WEBPACK FOOTER //
// ./assets/js/source/utils/Graph.js